/**
 * @Des AMap 高德地图
 * @Auth
 * @Date
 */

// 引入组件 HanshMap
import {HashMap} from '@/static_dazzle/plugins/tools/hashmap';
import AMapLoader from '@amap/amap-jsapi-loader';

// 高德地图 组件
export function mapGPSGaode() {
	// 地图
	var mapItem = null;
	// 地理编码
	var geocoder = null;
	// 控制 组件
	var controlBar = null;
	// 组件 测距
	var mouseTool = null;
	// 测距 工具
	var rangingTool = null;
	// 信息弹窗
	var infoWindow = null;
	// 点聚合
	var markerCluster = null;
	// 海量点
	var markerMass = null;
	
	// 缓存 list marker
	var map_list_marker = new HashMap();
	// 缓存 list polyline
	var map_list_polyline = new HashMap();
	
	// 缓存 list infoWindow
	var map_list_infoWindow = new HashMap();
	// infoWindowDid
	var infoWindowDid = '';
	
	// AMap 私钥
	const MAP_KEY = '2f3545dbc13a4187c2077c8acc07b711';// '309f07ac6bc48160e80b480ae511e1e9';
	// AMap
	var AMap = null;
	// 地图控制组件 默认参数
	var options_plugins_default = {
		//实现默认图层与卫星图、实施交通图层之间切换的控件
		'MapType': {
			defaultType: 0,
			position: { right: '20px', top: '140px', }
		},// 'AMap.MapType'
	};// options_plugins_default
	
	var that = this;
	/**
	 * @Des 获取 AMap
	 * @Auth
	 * @Date
	 */
	this.getAMap = function () {
		return AMap;
	};// getAMap
	/**
	 * @Des 获取 mapItem
	 * @Auth
	 * @Date
	 */
	this.getAMap = function () {
		return mapItem;
	};// getAMap
	
	/**
	 * @Des 加载 AMap
	 * @Auth
	 * @Date
	 */
	function loadAMap() {
		return AMapLoader.load({
			key: MAP_KEY,
			version: "2.0",
			plugins: [
				'AMap.ControlBar',
				'AMap.ToolBar',
				'AMap.Scale',
				'AMap.MapType',
				'AMap.MarkerClusterer',
				'AMap.Geocoder',
				'AMap.PolylineEditor',
				'AMap.RangingTool',
				'AMap.PolygonEditor',
				'AMap.MouseTool',
				'AMap.RectangleEditor',
				'AMap.CircleEditor',
				'AMap.Adaptor',
				// 地址自动搜索
				'AMap.AutoComplete',
				'AMap.PlaceSearch'
			],
			Loca:{
				version: '2.0.0',
			}
		})
	};
	/**
	 * @Des 地图 初始化
	 * @Auth
	 * @Date
	 */
	this.initMap = async function (eleId, opts={}, callBack) {
		let opts_default = {
			isHotspot: false,
			resizeEnable: true,
			rotateEnable: true,
			pitchEnable: true,
			showBuildingBlock: true,
			showIndoorMap: true,
			zoom: 3.75,
			zooms: [3.75, 20],
			pitch: 0,
			rotation: 0,
			viewMode: '2D',
			// center: [113.86, 22.5798],
			mapStyle: "amap://styles/fresh",
			lang: "en", //可选值：en，zh_en, zh_cn
			WebGLParams:{
				preserveDrawingBuffer:true
			},
		};
		
		// mapStyle "amap://styles/?"
		// 标准 normal 幻影黑 dark 月光银 light 远山黛 whitesmoke 草色青 fresh 雅士灰 grey 涂鸦 graffiti 马卡龙 macaron 靛青蓝 blue 极夜蓝 darkblue 酱籽 wine
		
		AMap = await loadAMap();
		mapItem = new AMap.Map(eleId, Object.assign({}, opts_default, opts));
		
		// 信息窗体
		infoWindow = this.creatInfoWindow();
		// this.infoWindow = infoWindow;
		
		// 控制组件 初始化
		opts.controlBarFlag !== false && this.initControlBar();
		
		// 模块 地理编码
		opts.geocoderFlag !== false && this.initGeocoder();
		
		// 添加 地图控制插件
		opts.mapPluginsFlag !== false && this.initMapPlugins();
		
		// 添加 鼠标事件
		this.initMouseTool();
		
		typeof callBack == 'function' && callBack(AMap);
		
	};// initMap
	
	//	// 添加地图 控制插件
//	map.plugin(["AMap.ToolBar"], function () {
//	map.addControl(new AMap.ToolBar()); // 工具条控件;范围选择控件
//	});
//	map.plugin(["AMap.Scale"], function () {
//	map.addControl(new AMap.Scale()); // 比例尺条控件
//	});
//	map.plugin(["AMap.Geolocation"], function () {
//	map.addControl(new AMap.Geolocation()); //定位当前位置插件； 用来获取和展示用户主机所在的经纬度位置；
//	});
//	map.plugin(["AMap.OverView"], function () {
//	map.addControl(new AMap.OverView()); //鹰眼插件；在地图右下角显示地图的缩略图
//	});
//	map.plugin(["AMap.MapType"], function () {
//	map.addControl(new AMap.MapType()); //实现默认图层与卫星图、实施交通图层之间切换的控件
//	});

//	map.plugin(["AMap.Geocoder"], function () {
//		mgeocoder = new AMap.Geocoder({
//			city: "010", //城市设为北京，默认：“全国”
//			radius: 1000 //范围，默认：500
//		}); //地理编码、逆地理编码
//	});
	
	/**
	 * @Des 控制组件 初始化
	 * @Auth
	 * @Date
	 */
	this.initControlBar = function (opt) {
		let option_default = {
			position: {
				right: '20px',
				top: '40px',
			},
			showZoomBar: false,
		};
		controlBar = new AMap.ControlBar(Object.assign({}, option_default, opt));
		controlBar.addTo(mapItem);
	};// initControlBar
	
	/**
	 * @Des 模块 地理编码
	 * @Auth
	 * @Date
	 */
	this.initGeocoder = function (opt) {
		let option_default = {
			city: "010", //城市设为北京，默认：“全国”
			radius: 1000 //范围，默认：500
		};
		geocoder = new AMap.Geocoder(Object.assign({}, option_default, opt));
	};// initGeocoder
	
	/**
	 * @Des 地图控制插件
	 * @Auth
	 * @Date
	 */
	this.initMapPlugins = function (plugins=[{pluginKey: 'MapType', opt: {}}]) {
		Object.assign([], plugins).forEach((row, index) => {
			let pluginKey = row.pluginKey;
			mapItem.plugin([('AMap.' + pluginKey)], function () {
				let option_default = Object.assign({}, options_plugins_default[pluginKey]);
				let _plugin = new AMap[pluginKey](Object.assign({}, option_default, row.opt));
				mapItem.addControl(_plugin);
			});
		});
	};// initMapPlugins
	
	/**
	 * @Des 地图插件 鼠标事件工具
	 * @Auth
	 * @Date
	 */
	this.initMouseTool = function () {
		/** 测距 */
		mouseTool = new AMap.MouseTool(mapItem);
		
		let startMarkerOptions = {
			icon: new AMap.Icon({
				size: new AMap.Size(19, 31),//图标大小
				imageSize: new AMap.Size(19, 31),
				image: "//webapi.amap.com/theme/v1.3/markers/b/start.png",
			}),
			offset: new AMap.Pixel(-9, -31),
		};
		let endMarkerOptions = {
			icon: new AMap.Icon({
				size: new AMap.Size(19, 31),//图标大小
				imageSize: new AMap.Size(19, 31),
				image: "//webapi.amap.com/theme/v1.3/markers/b/end.png",
			}),
			offset: new AMap.Pixel(-9, -31),
		};
		let midMarkerOptions = {
			icon: new AMap.Icon({
				size: new AMap.Size(19, 31),//图标大小
				imageSize: new AMap.Size(19, 31),
				image: "//webapi.amap.com/theme/v1.3/markers/b/mid.png",
			}),
			offset: new AMap.Pixel(-9, -31),
		};
		let lineOptions = {
			strokeStyle: "solid",
			strokeColor: that.getColor(),
			strokeOpacity: 1,
			strokeWeight: 2,
		};
		let rulerOptions = {
			startMarkerOptions: startMarkerOptions,
			midMarkerOptions: midMarkerOptions,
			endMarkerOptions: endMarkerOptions,
			lineOptions: lineOptions,
		};
		rangingTool = new AMap.RangingTool(mapItem, rulerOptions);
		rangingTool.on('end', distanceMeasurementLogicProcessing);
	}// initMouseTool
	function distanceMeasurementLogicProcessing(even) { 
		even.polyline._opts.strokeColor = that.getColor();
	};// distanceMeasurementLogicProcessing
	/** 获取随机色 */
	this.getColor = function () {
		let r = parseInt(Math.random() * 256);
		let g = parseInt(Math.random() * 256);
		let b = parseInt(Math.random() * 256);
		return `rgba(${r},${g},${b},1)`;
	};// getColor
	
	/** 右键菜单 */
	this.onContextmenu = function (self, event) {
		self.$contextmenu({
			items: [
				/** 缩放显示 */
				{
					label: "缩放",
					icon: "el-icon-camera",
					divided: true,
					minWidth: 0,
					children: [
					{
						label: "放大",
						icon: "el-icon-zoom-in",
						onClick: () => {
							mapItem.setZoomAndCenter(20, _myMouseMovement);
						},
					},
					{
						label: "缩小",
						icon: "el-icon-zoom-out",
						onClick: () => {
							mapItem.setZoomAndCenter(3.75, _myMouseMovement);
						},
					}],
				},
				/** 测距 */
				{
					label: "测距",
					icon: "el-icon-edit",
					minWidth: 0,
					children: [
						{
							label: "标点",
							icon: "el-icon-location-information",
							onClick: () => {
								rangingKeepClose();
								mouseTool.marker();
							},
						},
						{
							label: "画圆",
							icon: "el-icon-loading",
							onClick: () => {
								rangingKeepClose();
								mouseTool.circle();
							},
						},
						{
							label: "画矩形",
							icon: "el-icon-sort-down",
							onClick: () =>
							{
								rangingKeepClose();
								mouseTool.rectangle();
							},
						},
						{
							label: "画折线",
							icon: "el-icon-sort-up",
							onClick: () => {
								rangingKeepClose();
								mouseTool.polyline();
							},
						},
						{
							label: "画多边形",
							icon: "el-icon-rank",
							onClick: () => {
								rangingKeepClose();
								mouseTool.polygon();
							},
						},
						{
							label: "距离测量",
							icon: "el-icon-edit",
							onClick: () => {
								self.$message({
									message: '开启距离测量,鼠标双击或右键结束当前测量',
									type: 'success',
								});
								rangingKeepClose();
								// mouseTool.rule(rangingTool)
								rangingTool.turnOn();
							},
						},
						{
							label: "面积测量",
							icon: "el-icon-edit",
							onClick: () => {
								self.$message({
									message: '开启面积测量,鼠标双击或右键结束当前测量',
									type: 'success',
								});
								rangingKeepClose();
								let color = that.getColor();
								mouseTool.measureArea({
									strokeColor: color,
									fillColor: color,
									fillOpacity: 0.3,
								});
							},
						},
					],
				},
				{
					label: "关闭测距工具",
					icon: "el-icon-close",
					divided: true,
					minWidth: 0,
					children: [
						{
							label: "关闭并保留",
							icon: "el-icon-close",
							onClick: () => {
								rangingKeepClose();
							},
						},
						{
							label: "关闭并清除",
							icon: "el-icon-close",
							onClick: () => {
								rangingClearClose();
							},
						}
					],
				},
			],
			// event, event.clientX event.clientY
			x: event.clientX,
			y: event.clientY,
			customClass: "class-a",
			zIndex: 3,
			minWidth: 150,
		});
		return false;
	};// onContextmenu
	/** 清除close工具 */
	function rangingClearClose() {
		mouseTool.close(true);
		rangingTool.turnOff(true);
	};// rangingClearClose
	/** 保留close工具 */
	function rangingKeepClose() {
		mouseTool.close(false);
		rangingTool.turnOff(false);
	};// rangingKeepClose
	
	// 缩放
	this.setZoom = function (zoom) {
		// 空值 中止
		if (!mapItem) return false;
		mapItem.setZoom(zoom);
	};// setZoom
	// 中心
	this.setCenter = function (position) {
		// 空值 中止
		if (!mapItem) return false;
		mapItem.setCenter(position);
	};// setCenter
	// 中心
	this.setZoomAndCenter = function (zoom, position) {
		// 空值 中止
		if (!mapItem) return false;
		mapItem.setZoomAndCenter(zoom, position);
	};// setZoomAndCenter
	
	// ============================================== 地理编码 逆地理编码 start ============================================== //
	/**
	 * @Des 地理编码
	 * @param address '地理位置' 或 ['地理位置1', '地理位置2', ...]
	 * @Auth
	 * @Date
	 */
	this.geoCode = function (address, callBack) {
		geocoder.getLocation(address, function(status, result) {
            typeof callBack == 'function' && callBack(status, result);
            
//          if (status === 'complete'&&result.geocodes.length) {
//          	var lnglat = result.geocodes[0].location
//              marker.setPosition(lnglat);
//              map.add(marker);
//              map.setFitView(marker);
//          }else{
//          	log.error('根据地址查询位置失败');
//          }
			
		});
	};// geoCode
	/**
	 * @Des 初始化 自动搜索
	 * @param opt {input: "tipinput"}
	 * @Auth
	 * @Date
	 */
	this.initAutocomplete = function (opt) {
		// 实例化Autocomplete
		let autocomplete = new AMap.Autocomplete(Object.assign({city: '全国'}, opt));
		let placeSearch = new AMap.PlaceSearch({
			map: mapItem
		});  //构造地点查询类
		AMap.event.addListener(autocomplete, "select", select);//注册监听，当选中某条记录时会触发
		
		this.setPlace = function (adcode, address) {
			placeSearch.setCity(adcode);
			placeSearch.search(address);  //关键字查询查询
		};
		this.clearPlace = function () {
			// 清除 placeSearch marker
			placeSearch.clear();
			if (placeSearch.render) {
				placeSearch.render.markerList.clear();
			}
		};
		
		function select(e) {
			placeSearch.setCity(e.poi.adcode);
			placeSearch.search(e.poi.name);  //关键字查询查询
		}
	};// initAutocomplete
	
	/**
	 * @Des 逆地理编码
	 * @param lnglat [lng, lat] 或 [[lng1, lat1], [lng2, lat2], ...]
	 * @Auth
	 * @Date
	 */
	this.regeoCode = function (lnglat, callBack) {
		geocoder.getAddress(lnglat, function(status, result) {
			typeof callBack == 'function' && callBack(status, result);
			
//			if (status === 'complete'&&result.regeocode) {
//				var regeocodes = result.regeocodes;
//				var address = result.regeocode.formattedAddress;
//				document.getElementById('address').value = address;
//			}else{
//				log.error('根据经纬度查询地址失败')
//			}
			
        });
	};// regeoCode
	// ============================================== 地理编码 逆地理编码 end ============================================== //
	
	// 创建 信息窗体
	this.creatInfoWindow = function () {
		/** 信息窗体 */
		return new AMap.InfoWindow({
			autoMove: true,
			anchor: 'middle-right',
			closeWhenClickMap: true,
			offset: new AMap.Pixel(-15, -10),
			isCustom: true,
		});
	};// creatInfoWindow
	// 更新 信息窗体
	this.updateInfoWindow = function (markerId, infoContent) {
		// 空值 中止
		if (!infoWindow) return false;
		infoWindowDid = markerId;
		infoWindow.setContent(infoContent);
	};// updateInfoWindow
	// 打开 信息窗体
	this.openInfoWindow = function (position) {
		// 空值 中止
		if (!infoWindow) return false;
		infoWindow.open(mapItem, position);
	};// openInfoWindow
	// 关闭 信息窗体
	this.closeInfoWindow = function (markerId) {
		// 空值 中止
		if (!infoWindow) return false;
		if (!markerId || infoWindowDid == markerId) {
			infoWindow.close();
			// infoWindowDid
			infoWindowDid = '';
		}
	};// closeInfoWindow
	
	// 创建 像素范围
	this.creatPixel = function (offsetY=0, offsetX=0) {
		return new AMap.Pixel(offsetY, offsetX);
	};// creatPixel
	// 创建 size
	this.creatSize = function (width=40, height=40) {
		return new AMap.Size(width, height);
	};// creatSize
	
	// 创建 icon
	this.creatIcon = function (opt={}) {
		let _opt = {
			image: opt.icon,
			imageSize: new AMap.Size(opt.imageSize ? opt.imageSize[0] : 40, opt.imageSize ? opt.imageSize[1] : 40),
		}
		if (opt.size) {
			_opt.size = new AMap.Size(opt.size ? opt.size[0] : 40, opt.size ? opt.size[1] : 40);
		}
		return new AMap.Icon(Object.assign({}, _opt));
	};// creatIcon
	
	// 创建 position
	this.creatPosition = function (lng, lat) {
		return new AMap.LngLat(lng, lat);
	};// creatPosition
	
	// 创建视图
	this.creatBounds = function (lnglats) {
		/*
		let _lnglats = [
			[117.25945481181146, 36.74937489596646], // 图片左下角经纬度坐标
			[117.26525481181146, 36.75347489596646] // 图片右上角经纬度坐标，可以根据图片大小调整坐标值
		];
		*/
		return new AMap.Bounds(Object.assign([], lnglats)[0], Object.assign([], lnglats)[1]);
	};// creatBounds
	
	// 计算角度 
	// 参数 preLatLng=[lat, lng], curLatLng=[lat, lng]
	this.latLngAngle = function (preLatLng=[], curLatLng=[]) {
		if (!preLatLng[0] || !preLatLng[1] || !curLatLng[0] || !curLatLng[1]){
			console.error('有经纬度不存在，返回初始角度')
			return 0
		}
		let dRotateAngle = Math.atan2(Math.abs(preLatLng[0] - curLatLng[0]), Math.abs(preLatLng[1] - curLatLng[1]));
		if(preLatLng[0]>=curLatLng[0]){
			if(preLatLng[1]>=curLatLng[1]){}else{
				dRotateAngle=Math.PI-dRotateAngle;
			}
		}else{
			if(preLatLng[1]>=curLatLng[1]){
				dRotateAngle=2*Math.PI-dRotateAngle;
			}else{
				dRotateAngle=Math.PI+dRotateAngle;
			}
		}
		dRotateAngle=dRotateAngle*180/Math.PI;
		return Math.abs(dRotateAngle-360)
	};// latLngAngle
	
	// 创建 marker
	this.creatMarker = function (opt={}) {
		let opt_default = {
			// title: didInfo.address,
			label: {
				content: '',
				direction: "top",
				offset: [-10, 0],
			},
			anchor: 'center',
			// position: [parseFloat(didInfo.lngGc), parseFloat(didInfo.latGc)],
			offset: [0, -10],
			icon: 'a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',// didInfo.statusWorking === 18 ? "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png" : "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
			// extData: {"markerID": didInfo.did, "markerItem": didInfo},
		};
		
		let _opt = Object.assign({}, opt_default, opt);
		
		// 创建 像素范围
		const offset = this.creatPixel(_opt.offset[0], _opt.offset[1]);
		_opt.offset = offset;
		
		if (_opt.label.content) {
			const labelOffset = this.creatPixel(_opt.label.offset[0], _opt.label.offset[1]);
			_opt.label.offset = labelOffset;
		} else {
			delete _opt['label'];
		}
		
		/** 标点 */
		let marker = new AMap.Marker(Object.assign({}, _opt));
		// marker.content = this.myMarkerContent(didInfo, one);
		
		typeof _opt.clickMarker == 'function' ? marker.on('click', _opt.clickMarker) : marker.on('click', clickMarker);
		typeof _opt.dbClickMarker == 'function' ? marker.on('dbclick', _opt.dbClickMarker) : marker.on('dbclick', dbClickMarker);
		
		if (typeof _opt.rightClickMarker == 'function') {
			marker.on('rightclick', _opt.rightClickMarker);
		}
		return marker;
	};// creatMarker
	// 添加 marker
	this.addMarker = function (markerId, marker) {
		// 缓存 list marker
		map_list_marker.put(markerId, marker);
		mapItem.add(marker);
		// 更新 信息窗体
		infoWindowDid == markerId && this.updateInfoWindow(markerId, marker.content);
	};// addMarker
	// 添加 markers
	this.addMarkers = function (markers) {
		mapItem.add(markers);
		// 更新 缓存
		markers.forEach((marker, index) => {
			let markerID = marker.getExtData().markerID;
			// 缓存 list marker
			map_list_marker.put(markerID, marker);
			
			// 更新 信息窗体
			infoWindowDid == markerID && this.updateInfoWindow(markerID, marker.content);
		});
	};// addMarkers
	// 移除 marker
	this.removeMarker = function (markerId) {
		// 缓存 list marker
		let marker = map_list_marker.get(markerId);
		// closeInfoWindow
		// infoWindowDid == markerId && this.closeInfoWindow();
		marker && mapItem.remove(marker);
	};// removeMarker
	// 移除 markers
	this.removeMarkers = function () {
		// 获取 markers
		let markers = this.getMapMarkers();
		markers.length > 0 && mapItem.remove(markers);
		// 缓存 list marker
		map_list_marker.clear();
	};// removeMarker
	// marker 设置位置
	this.setMarkerPosition = function (marker, lnglat) {
		marker.setPosition(lnglat);
	};// setMarkerPosition
	// marker 为中心 设置满级视图
	this.setFitViewByMarker = function (marker) {
		mapItem.setFitView(marker);
	};// setFitViewByMarker
	// 获取 markers
	this.getMapMarkers = function (markerId) {
		let markers = mapItem.getAllOverlays("marker");
		let filters = markerId ? markers.filter(value => value.getExtData().markerID === markerId) : markers;
		return Object.assign([], filters);
	};// getMapMarkers
	/** 点击marker */
	function clickMarker(e) { 
		let position = e.target.getPosition();
		infoWindow.setContent(e.target.content);
		infoWindow.open(mapItem, position);
		mapItem.setCenter(position);
		
		let extData = e.target.getExtData();
		infoWindowDid = extData.markerID;
	};// clickMarker
	function dbClickMarker(e) {
		infoWindow.setContent(e.target.content);
		infoWindow.open(mapItem, e.target.getPosition());
		mapItem.setZoomAndCenter(20, e.target.getPosition());
		
		let extData = e.target.getExtData();
		infoWindowDid = extData.markerID;
	};// dbClickMarker
	
	// 清空地图
	this.clearMap = function () {
		// 清除 覆盖物
		mapItem && mapItem.clearMap();
		
		// 缓存 list marker
		map_list_marker.clear();
		// 缓存 list polyline
		map_list_polyline.clear();
	};// clearMap
	// 销毁地图
	this.destroyMap = function () {
		// 清空地图
		this.clearMap();
		mapItem && mapItem.destroy();
	};// destroyMap
	// 设置合适视图
	this.setFitView = function () {
		mapItem.setFitView();
	};// setFitView
	
	// 添加
	this.addToMap = function(item){
		mapItem.add(item);
	};
	// 移除
	this.removeFromrMap = function(item){
		mapItem.remove(item);
	};
	
	var _myMouseMovement;
	var mousemoveCallBack;
	var clickCallBack;
	function MousemoveFn(e) {
		// _myThis.myMouseMovement = [e.lnglat.lng, e.lnglat.lat];
			_myMouseMovement = [e.lnglat.lng, e.lnglat.lat];
			typeof mousemoveCallBack == 'function' && mousemoveCallBack(e);
	}
	function ClickmapFn(e) {
		typeof clickCallBack == 'function' && clickCallBack(e);
	}
	// 鼠标事件
	this.bindMouseEvent = function (opt={}) {
		
		if (typeof opt.mousemoveCallBack == 'function') {
			mousemoveCallBack = opt.mousemoveCallBack;
		}
		if (typeof opt.clickCallBack == 'function') {
			clickCallBack = opt.clickCallBack;
		}
		
		/** 鼠标移动事件 */
		opt.mousemoveEventFlag && mapItem.on("mousemove", MousemoveFn);
		
		/** 鼠标左键点击事件 */
		opt.clickEventFlag && mapItem.on('click', ClickmapFn);
		
	};// bindMouseEvent
	this.offMouseEvent = function () {
		/** 鼠标移动事件 */
		mapItem.off("mousemove", MousemoveFn);
		/** 鼠标左键点击事件 */
		mapItem.off('click', ClickmapFn);
		
		mousemoveCallBack = null;
		clickCallBack = null;
		
	};// offMouseEvent
	
	// ======================================== 点聚合 start ======================================== //
	/** 点聚合 当前账户多于100台则聚合显示 */
	this.creatMarkerCluster = function (markers) {
		// 空值 中止
		if (!AMap) return false;
		if (markerCluster) {
            markerCluster.setMap(null);
            markerCluster = null;
		}
		let gridSize = 60;
		let sts = [{
			url: "//a.amap.com/jsapi_demos/static/images/blue.png",
			size: new AMap.Size(32, 32),
			offset: new AMap.Pixel(-16, -16),
		}, {
			url: "//a.amap.com/jsapi_demos/static/images/green.png",
			size: new AMap.Size(32, 32),
			offset: new AMap.Pixel(-16, -16),
		}, {
			url: "//a.amap.com/jsapi_demos/static/images/orange.png",
			size: new AMap.Size(36, 36),
			offset: new AMap.Pixel(-18, -18),
		}, {
			url: "//a.amap.com/jsapi_demos/static/images/red.png",
			size: new AMap.Size(48, 48),
			offset: new AMap.Pixel(-24, -24),
		}, {
			url: "//a.amap.com/jsapi_demos/static/images/darkRed.png",
			size: new AMap.Size(48, 48),
			offset: new AMap.Pixel(-24, -24),
		}];
		/** 完全自定义 */
		let _renderMarker = function (context) {
			
		};
		let _renderClusterMarker = function (context) {
			let factor = Math.pow(context.count / markers.length, 1 / 5);
			let div = document.createElement('div');
			let Hue = 180 - factor * 180;
			let bgColor = 'hsla(' + Hue + ',100%,40%,0.7)';
			let fontColor = 'hsla(' + Hue + ',100%,90%,1)';
			let borderColor = 'hsla(' + Hue + ',100%,40%,1)';
			let shadowColor = 'hsla(' + Hue + ',100%,90%,1)';
			div.style.backgroundColor = bgColor;
			let size = Math.round(30 + Math.pow(context.count / markers.length, 1 / 5) * 20);
			div.style.width = div.style.height = size + 'px';
			div.style.border = 'solid 1px ' + borderColor;
			div.style.borderRadius = size / 2 + 'px';
			div.style.boxShadow = '0 0 5px ' + shadowColor;
			div.innerHTML = context.count;
			div.style.lineHeight = size + 'px';
			div.style.color = fontColor;
			div.style.fontSize = '14px';
			div.style.textAlign = 'center';
			context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
			context.marker.setContent(div);
		};
		/** 创建点聚合对象 */
		markerCluster = new AMap.MarkerCluster(mapItem, markers, {
			gridSize: gridSize, // 设置网格像素大小
			maxZoom: 18,
			clusterByZoomChange: true,
			zoomOnClick: true,
			averageCenter: false,
			// styles: sts,
			renderClusterMarker: _renderClusterMarker, // 自定义聚合点样式
			// renderMarker: _renderMarker,            // 自定义非聚合点样式
		});
		
		// 检索 更新 infoWindow
		Object.assign([], markers).forEach((marker, index) => {
			let extData = marker.getExtData();
			// 更新 信息窗体
			infoWindowDid == extData.markerID && this.updateInfoWindow(extData.markerID, marker.content);
		});
		
		function clusterClick(e) {
			// console.log(e);
		}
	};// creatMarkerCluster
	this.getMarkerCluster = function () {
		return markerCluster;
	},// getMarkerCluster
	// 点集合 添加 marker
	this.addClusterMarker = function (marker) {
		// 空值 中止
		if (!markerCluster) {
			this.creatMarkerCluster([marker]);
			return false;
		}
		
		let position = marker.getPosition();
		let markers = [{lnglat: [position.lng, position.lat], originMarker: marker}];
		markerCluster.addData(markers);
		
		let extData = marker.getExtData();
		// 更新 信息窗体
		infoWindowDid == extData.markerID && this.updateInfoWindow(extData.markerID, marker.content);
	};// addClusterMarker
	// 点集合 移除 marker
	this.removeClusterMarker = function (markerId) {
		// 空值 中止
		if (!markerCluster) return false;
		
		let length = markerCluster._.length;
		let filter = null;
		let index = undefined;
		for(let i = 0; i < length; i++)
		{
			let newVar = markerCluster._[i];
			if (newVar.originMarker.className === "AMap.Marker" && newVar.originMarker.getExtData().markerID === markerId)
			{
				filter = newVar;
				index = i;
				break;
			}
		}
		if (index >=0) {
			markerCluster._[index].originMarker.setMap(null);
			markerCluster._.splice(index, 1);
		}
	};// removeClusterMarker
	// 点聚合 移除markers
	this.removeClusterMarkers = function () {
		// 空值 中止
		if (!markerCluster) return false;
		// 清除地图上所有 聚合
		if (typeof markerCluster.clearMarkers == 'function') {
			markerCluster.clearMarkers();
		} else {
			markerCluster.setMap(null);
			markerCluster = null;
		}
	};// removeClusterMarker
	// ======================================== 点聚合 end ======================================== //
	
	// ======================================== 海量点 start ======================================== //
	// 海量点 多余 200 海量点
	this.creatMassMarker = function (opt={}) {
		let option_default = {
			lnglat: opt.lnglat,// 位置 必要
			markerID: opt.markerID,
		};
		
		let _opt = Object.assign({}, option_default);
		if (opt.title) {
			_opt['title'] = opt.title;
		}
		if (opt.uploadTime) {
			_opt['uploadTime'] = opt.uploadTime;
		}
		if (opt.point) {
			_opt['point'] = opt.point;
		}
		if (opt.myContent) {
			_opt['myContent'] = opt.myContent;
		}
		
		return Object.assign({}, _opt);
	};// creatMassMarker
	/**
	 * @Des 创建海量点
	 * @Auth
	 * @Date 
	 */
	this.creatMassMarks = function (massMarkers=[], opt={}) {
		// 空值 中止
		if (!AMap) return false;
		if (markerMass) {
            markerMass.setMap(null);
            markerMass = null;
		}
		
		// 海量点 style
		var style_mass = [
			{
				url: '/static/images/map/outdoorIocns/icon-point-mass.png',
				anchor: new AMap.Pixel(10, 20),
				size: new AMap.Size(20, 20),
				zIndex: 1,
			}
		];
		// 默认 参数
		let option_default = {
			opacity: 0.8,
			zIndex: 111,
			cursor: 'pointer',
			style: style_mass,
		};
		
		markerMass = new AMap.MassMarks(massMarkers, Object.assign({}, option_default, opt));
		
		typeof opt.clickMarkerMass == 'function' ? markerMass.on('click', opt.clickMarkerMass) : markerMass.on('click', clickMarkerMass);
		
		markerMass.setMap(mapItem);
		return markerMass;
	};// creatMassMarks
	this.getMarkerMass = function () {
		return markerMass;
	},// getMarkerMass
	// 海量点 添加 marker
	this.addMassMarker = function (massMarkers=[]) {
		// 空值 中止
		if (!markerMass) return false;
		
		markerMass.addData(massMarkers);
		
		Object.assign([], massMarkers).forEach((massMarker, index) => {
			// 更新 信息窗体
			infoWindowDid == massMarker.markerID && this.updateInfoWindow(massMarker.markerID, massMarker.myContent);
		});
	};// addMassMarker
	// 海量点 移除 marker
	this.removeMassMarker = function (massMarkerId) {
		// 空值 中止
		if (!markerMass) return false;
		
		let length = markerMass._.length;
		let filter = null;
		let index = undefined;
		for(let i = 0; i < length; i++)
		{
			let newVar = markerMass._[i];
			if (newVar.originMarker.className === "AMap.Marker" && newVar.markerID === massMarkerId)
			{
				filter = newVar;
				index = i;
				break;
			}
		}
		index >=0 && markerMass._.splice(index, 1);
	};// removeMassMarker
	// 海量点 移除markers
	this.removeMassMarkers = function () {
		// 空值 中止
		if (!markerMass) return false;
		// 清除地图上所有 海量点
		if (typeof markerMass.clearMarkers == 'function') {
			markerMass.clearMarkers();
		} else {
			markerMass.setMap(null);
			markerMass = null;
		}
	};// removeMassMarkers
	
	// 点击 海量点
	function clickMarkerMass(e) {
		// 空值 中止
		if (!e.data.myContent) return false;
		
		infoWindow.setContent(e.data.myContent);
		infoWindow.open(mapItem, e.data.lnglat);
		mapItem.setCenter(e.data.lnglat);
		
		infoWindowDid = e.data.markerID;
	};// clickMarkerMass
	// ======================================== 海量点 end ======================================== //
	
	// ======================================== 覆盖物 image layer start ======================================== //
	/**
	 * @Des 创建 覆盖物 image
	 * 
	 * @param opt 
	 * {
	 * 	name:'智慧工厂',
	 * 	url: '/static/images/1.png', // 修改为你自己的图片链接
	 * 	bounds: [
	 * 		[117.25945481181146, 36.74937489596646], // 图片左下角经纬度坐标
	 * 		[117.26525481181146, 36.75347489596646] // 图片右上角经纬度坐标，可以根据图片大小调整坐标值
	 * 	],
	 * 	zIndex: 20, // 设置覆盖物的层级
	 * 	opacity: 1 ,// 设置覆盖物的透明度
	 * }
	 * 
	 * @Auth
	 * @Date
	 */
	this.creatImageLayer = function (opt) {
		// 创建视图
		let bounds = this.creatBounds(Object.assign({}, opt)['bounds']);
		let option_default = {
			name:'智慧工厂',
			url: '/static/images/1.png', // 修改为你自己的图片链接
			bounds: [
				[117.263744,36.750307], // 图片左下角经纬度坐标
				[117.261404,36.751647] // 图片右上角经纬度坐标，可以根据图片大小调整坐标值
			],
			zIndex: 20, // 设置覆盖物的层级
			opacity: 1 ,// 设置覆盖物的透明度
		}
		let img = new AMap.ImageLayer(Object.assign({}, option_default, opt, {bounds: bounds}));
		mapItem.add(img);
	};// creatImageLayer
	// ======================================== 覆盖物 image layer end ======================================== //
	
	// ======================================== 覆盖物 画线 polyline start ======================================== //
	// 创建 polyline
	this.creatPolyline = function (opt={}) {
		let opt_default = {
			path: [],
			showDir: true,
			dirColor: 'pink',
			// strokeColor: opt.color,
			strokeOpacity: 0.5,
			strokeWeight: 7,
			lineJoin: "round",
			lineCap: "round",
			/*extData: {
				"polyID": opt.polyID,
				"max": opt.max,
				"point": (opt.index + 1),
			},*/
		};
		
		let _opt = Object.assign({}, opt_default, opt);
		
		// 线
		let polyline = new AMap.Polyline(Object.assign({}, _opt));
		return polyline;
	};// creatPolyline
	// 添加 polyline
	this.addPolyline = function (polyId, polyline) {
		// 缓存 list polyId
		map_list_polyId.put(polyId, polyline);
		mapItem.add(polyline);
	};// addPolyline
	// 添加 polylines
	this.addPolylines = function (polylines) {
		mapItem.add(polylines);
		// 更新 缓存
		polylines.forEach((polyline, index) => {
			let polyID = polyline.getExtData().polyID;
			// 缓存 list polyline
			map_list_polyline.put(polyID, polyline);
		});
	};// addPolylines
	// 移除 polyline
	this.removePolyline = function (polyId) {
		// 缓存 list polyline
		let polyline = map_list_polyline.get(polyId);
		polyline && mapItem.remove(polyline);
	};// removePolyline
	// 移除 polylines
	this.removePolylines = function () {
		// 缓存 list polylines
		let polylines = this.getMapPolylines();
		polylines.length > 0 && mapItem.remove(polylines);
		// 缓存 list polyline
		map_list_polyline.clear();
	};// removePolylines
	// 获取 polylines
	this.getMapPolylines = function (polyId) {
		let polylines = mapItem.getAllOverlays("polyline");
		let filters = polyId ? markers.filter(value => value.getExtData().polyID === polyId) : polylines;
		return Object.assign([], filters);
	};// getMapPolylines
	// ======================================== 覆盖物 画线 polyline end ======================================== //
	
};// mapGPSGaode












// WEBPACK FOOTER //
// ./src/static_dazzle/plugins/amap/map_gps_gaode.js